export const USE_DEV_API = process.env.REACT_APP_USE_DEV_API === true
// also change in build-prod script in package.json
export const APP_VERSION = '1.27'
export const isDev = process.env.NODE_ENV === 'development'
export const isProduction = !isDev
// export const BASE_TITLE = (isDev ? "[DEV] " : "") + 'GTO BASE | ';

export const BASE_TITLE = `${USE_DEV_API ? '[DEV] ' : ''}GTO BASE | `

export const getSectionTitle = (title) => `${BASE_TITLE} ${title}`
export const ABS_THRESHOLD = 0.005 // abs 0.5% => hand is removed

export const STRIPE_PUBLIC_KEY =  USE_DEV_API ?
     "pk_test_51NuWekCq92gvss2B5qyUoVJrBcXY8juo6zPhvLK4dZ8zKDZtbNGvJFiOXGKvRGEZGXcLHxKVg9ZzbovvemG6gPit00GnldUh4b":
     "pk_live_51NuWekCq92gvss2B50B7535gaqyAtdUHgHJReXf5obAbEcUT9vByw78J24xC9ryqqJkOA52pe1bCWYxOoozAS8VT00yIlBSSdb"

